import Highway from '@dogstudio/highway';
import { getPosition } from '../utils.js';
// import { mouseMovefn } from 'utils.js';
export default class singleOffreRenderer extends Highway.Renderer {

	onEnter() {
		/*
		Effets prévus pour le btn play de la vidéo mais la vidéo ne sera présente qu'en v2
		*/
		// this.DOM.view.querySelector('.video__section').addEventListener('mousemove', mouseMovefn);
		// this.DOM.view.addEventListener('mouseleave', (e) => {
			// 	TweenMax.to(e.currentTarget.querySelectorAll('[data-mouse-parallax]'), 1.2, {x:0, y:0, ease:Power3.easeOut});
			// });

			this.DOM = { view: this.wrap.lastElementChild };
			const jobInfos = this.DOM.view.querySelector('.job__infos');
			const jobProcess = this.DOM.view.querySelector('.job__process');
			const jobMain = this.DOM.view.querySelector('.job__main');
			this.DOM.jobInfos = jobInfos;
			this.DOM.jobProcess = jobProcess;
			this.DOM.jobMain = jobMain;


			this.addEvents();
			TweenMax.ticker.addEventListener('tick', this.visualFixed, this, true, 1);

			$('.open-apply-popup-link').magnificPopup({
				type:'inline',
				midClick: true
			});

			function check_favorite() {
			// CHECK FAVORITE
			var ajaxurl = $("#toggle-favorite").data("favorite");
			$.ajax({
				type: "GET",
				url: ajaxurl,
				data: "",
				success: function(data) {
					data = JSON.parse(data);
					if (window.DEVMODE) console.log("favorite : " + data.check);
					if (data.check) {
						$('#toggle-favorite').attr("checked",true);
					}
				},
				error: function(data) {
				}
			});
		}

		// ADD FAVORITE
		$("#toggle-favorite").on("click",function(e){
			// e.preventDefault();
			var self = $(this);
			var ajaxurl = self.data("ajaxurl");
			// Back office
			$.ajax({
				type: "GET",
				url: ajaxurl,
				data: "",
				success: function(data) {
					$('#toggle-favorite').attr("checked",data.check);
					if (window.DEVMODE) console.log(data.status);
				},
				error: function(data) {
					if (window.DEVMODE) console.log(data);
				}
			});
		});

		// GET NAME FILE
		$('.inputfile').on("change",function(){
			var file_name = $(this).val().replace(/.*[\/\\]/, '');
			$(this).siblings('.file_name').text(file_name);
			$(this).siblings('.delete_file').removeClass("hide");
		});

		// DELETE UPLOAD FILE
		$('.delete_file').on("click",function(e){
			$(this).siblings('.inputfile').val("");
			$(this).siblings('.file_name').text("");
			$(this).addClass("hide");
		});

		$("#form_candidate").on("submit",function(e){
			e.preventDefault();
			if (window.DEVMODE) console.log("-SEND-");
			$("body").css("cursor", "wait");
			$("#valid").attr("disabled", true);

			var self = $(this);
			var ajaxurl = self.data("ajaxurl");
			var form = document.getElementById('form_candidate');
			var data = new FormData(form);

			if (window.DEVMODE) console.log(ajaxurl);
			if (window.DEVMODE) console.log(data);

			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: data,
				contentType: false,
				processData: false,
				cache: false,
				success: function(data) {
					$("#valid").attr("disabled", false);
					$("body").css("cursor", "default")
					data = JSON.parse(data);
					console.log(data.wrong_extension);
					$("#result").text(data.message).css("color","red");
					data.wrong_extension == true  ? $(".labels_input_file").css("border-color","red"): $(".labels_input_file").css("border-color","#000");
					if(data.status)$("#form_candidate").hide();

				},
				error: function(data) {
					$("#valid").attr("disabled", false);
					$("body").css("cursor", "default")
				}
			});
		})

		$("#form_candidate").on("submit",function(e){
			e.preventDefault();
		})

		check_favorite()
	}

	addEvents() {
		this.sy = 0;
		window.addEventListener('scroll', () => {
			this.sy = window.pageYOffset || document.documentElement.scrollTop;
		});
	}

	visualFixed() {

		if (window.innerWidth < 992) return;

		const start = getPosition(this.DOM.jobMain).y - this.sy;
		const end = getPosition(this.DOM.jobProcess).y - this.sy;
		const isFixed = start <= 0 && end >= 560;

		if (!isFixed && start > 0) {
			TweenLite.set(this.DOM.jobInfos, {y: 0, ease: Power0});
		}

		if (isFixed) {
			TweenLite.set(this.DOM.jobInfos, {y: start * - 1, ease: Power0});
		}
	}

	onLeaveCompleted() {
		TweenMax.ticker.removeEventListener('tick', this.visualFixed);
	}

}
